import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { TextHeaderCell } from '../../bridgeNetworkAllowlist/TextHeaderCell';

export function RoutingFilterTableHeader() {
  return (
    <thead>
      <tr>
        <TextHeaderCell testId={'routing-filter-header'} text={Messages.bridgeSiteSettingsRoutingFiltersColumn()} />
        <TextHeaderCell testId={'routing-filter-permission-header'} text={Messages.bridgeSiteSettingsRoutingFilterPermissionType()} />
        <TextHeaderCell testId={'routing-filter-pool-header'} text={Messages.bridgeSiteSettingsRoutingFilterPool()} />
        <TextHeaderCell testId={'routing-filter-status-header'} text={Messages.status()} />
        <TextHeaderCell testId={'routing-filter-actions-header'} text={Messages.actions()} />
      </tr>
    </thead>
  );
}
